const INTENT_KEY = 'kazna:reauth-intent';
const UUID = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/iu;
export const SIGN_IN_METHODS = '/account/sign-in-methods';
export type ReauthIntent = { challengeId: string; epoch: string; actionId?: string; grantUntil?: number; ready?: boolean };

// Call only with the retained expected action, after backend challenge/action
// checks. Arbitrary returnTo is deliberately not part of this contract.
export function reauthReturnPath(actionId: string | undefined): string {
  if (actionId === undefined) return SIGN_IN_METHODS;
  if (!UUID.test(actionId)) throw new Error('Недопустимое подтверждение почты');
  return `/auth/email/link?actionId=${actionId}`;
}
export function readReauthIntent(): ReauthIntent | undefined {
  try {
    const value = JSON.parse(sessionStorage.getItem(INTENT_KEY) ?? 'null') as ReauthIntent | null;
    if (!value || !UUID.test(value.challengeId) || typeof value.epoch !== 'string') return;
    reauthReturnPath(value.actionId);
    if (value.grantUntil !== undefined && (!Number.isFinite(value.grantUntil) || value.grantUntil < 0)) return;
    return { challengeId: value.challengeId, epoch: value.epoch, ...(value.actionId ? { actionId: value.actionId } : {}), ...(value.grantUntil !== undefined ? { grantUntil: value.grantUntil } : {}), ...(value.ready === true ? { ready: true } : {}) };
  } catch { return; }
}
export function saveReauthIntent(intent: ReauthIntent): void {
  // Only nonsensitive challenge/action IDs, epoch and conservative timer.
  sessionStorage.setItem(INTENT_KEY, JSON.stringify(intent));
}
export function ownsReauthIntent(owned: ReauthIntent | undefined): boolean {
  const current = readReauthIntent();
  return Boolean(owned && current?.challengeId === owned.challengeId && current.epoch === owned.epoch && current.actionId === owned.actionId);
}
export function clearReauthIntent(owned: ReauthIntent | undefined): void {
  // A late response must not erase a newer challenge, action or account flow.
  if (ownsReauthIntent(owned)) sessionStorage.removeItem(INTENT_KEY);
}
export function hasFreshReauth(epoch: string, actionId?: string): boolean {
  const intent = readReauthIntent();
  return intent?.epoch === epoch && intent.actionId === actionId && intent.ready === true && (intent.grantUntil ?? 0) > Date.now();
}
